import React from 'react';
import styled from 'styled-components';

import imgFooterWhat from '../../images/iconos/whatsapp.png';
import imgFooterface from '../../images/iconos/facebook.png';
import imgFooterinst from '../../images/iconos/instagram.png';
import imgFooteryou from '../../images/iconos/youtube.png';

const FooterDiv1 = () => {

    const abrirFacebook = () => {
        window.location.href="https://www.facebook.com/ClubEcoturisticoFlorDelGuaviare/"
    }

    const abrirWhatsApp = () => {
        alert("Lo sentimos, Pronto estará habilitado para chat de WhatsApp")
    }

    const abrirInstagram = () => {
        window.location.href= "https://www.instagram.com/flordelguaviare/"
    }

    const abrirYoutube = () => {
        window.location.href="https://www.youtube.com/watch?v=7lVh-6TrDMo"
    }


    return(
        <Footerdiv1CSS>
        <div className="Red1Social" title=" Ir a WhatsApp" onClick= {abrirWhatsApp}>
            <img src={ imgFooterWhat} alt= "/" />
            <h3>  3182994670</h3>
        </div>
        <div className="Red1Social" title="Ir a Facebook" onClick={ abrirFacebook } target="_blank">
            <img src={ imgFooterface} alt= "/" />
            <h3>Club Ecoturístico Flor del Guaviare</h3>
        </div>
        <div className="Red1Social" onClick = { abrirInstagram } title="Ir a Instagram">
            <img src={ imgFooterinst} alt= "/" />
            <h3>Ecoturístico Flor del Guaviare</h3>
        </div>
        <div className="Red1Social" title="Ver Video Youtube" onClick={ abrirYoutube }>
            <img src={ imgFooteryou} alt= "/" />
            <h3>Club Ecoturístico Flor del Guaviare</h3>
        </div>
    </Footerdiv1CSS>
    )
}
export default FooterDiv1;

const Footerdiv1CSS = styled.div`
    width: 33.3%;
    position: relative;
    box-shadow: 1px 1px 1px 1px green;
    @media(max-width: 768px) {
        width: 100%;
        margin-bottom: 5%;
    }
    @media(max-width: 480px) {
        width: 100%;
        margin-bottom: 5%;
        top:2%;
     
    }
    @media(max-width: 320px) {
        width: 100%;
        margin-bottom: 5%;
    }
    .Red1Social {
        box-shadow: 1px 1px 1px 1px  green;
        margin: 2%;
        height:20%;
        display: flex;
        cursor: pointer;
    }
    .Red1Social img {
        width:10%;
        height: 80%;
        position:relative;
        float: left;
    }
    .Red1Social h3 {
        color: #fff;
        margin: 2%;
        margin-top:1%;
        font-family: widen latin;
        @media(max-width: 480px) {
        text-align: left;
        }
        @media(max-width: 320px) {
        text-align: left;
        }
    }
`;